<p>edit-having-images works!</p>
